import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const SPINNER_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round"><path d="M12 3a9 9 0 1 0 9 9"/></svg>`;

export const SITE_BACKDROP_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="10" r="3"/><path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z"/></svg>`;
export const AREA_BACKDROP_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7l7-3 9 4-1 9-8 3-7-4z"/></svg>`;

export interface BackdropControlLabels {
  show: string;
  hide: string;
  loading: string;
}

export interface BackdropControlState {
  isShown: boolean;
  isLoading: boolean;
}

/** Loads a map backdrop on first press, then shows and hides it. */
export class BackdropControl {
  private container!: HTMLElement;
  private button!: HTMLButtonElement;
  private readonly translate = inject(TranslateService);

  constructor(
    private readonly icon: string,
    private readonly labels: BackdropControlLabels,
    private readonly onToggle: () => void
  ) {}

  onAdd(): HTMLElement {
    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';

    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.className = 'mapboxgl-ctrl-icon';
    this.button.style.padding = '3px';
    this.button.innerHTML = this.icon;
    // Dimmed until the backdrop is on, so the button reads as a state and not just an action.
    this.button.style.opacity = '0.55';
    this.button.title = this.translate.instant(this.labels.show);
    this.button.onclick = () => this.onToggle();

    this.container.appendChild(this.button);
    return this.container;
  }

  onRemove(): void {
    this.container.parentNode?.removeChild(this.container);
  }

  update(state: BackdropControlState): void {
    if (!this.button) {
      return;
    }

    this.button.disabled = state.isLoading;
    this.button.innerHTML = state.isLoading ? SPINNER_ICON : this.icon;
    this.button.style.opacity = state.isShown && !state.isLoading ? '1' : '0.55';

    const label = state.isLoading
      ? this.labels.loading
      : state.isShown
        ? this.labels.hide
        : this.labels.show;
    this.button.title = this.translate.instant(label);
  }
}
